


export const taxSpecialismeListWordpress=['Compensation Tax','Energy Tax','Financial Services Tax','Indirect Tax','Real Estate Tax','M&A Tax',
    'Private Client and Family Office Taxation','Tax Disputes','Transfer Pricing','International Tax','Corporation Tax',
'Personal Taxation','Digital Taxation','Tax Compliance','Funds Tax','Property Tax','Stamp Duty','Grants and Incentives Tax - Research and Development Tax Credits',
'Inheritance Tax','Environmental Tax']
